import { useEffect } from 'react';

const DEFAULT_OG_IMAGE =
  'https://opengraph.b-cdn.net/production/images/53fc8c84-a4ad-44f8-bc0c-5d79cdb7c793.png?token=eB0PK_ziBTA0Rj6LPb2yZG7YFkp_Swe_3lB5LbAAG9E&height=630&width=1200&expires=33292321183';

const DEFAULT_DESCRIPTION =
  'Track 15,000+ Pokémon cards with real-time market prices, smart analytics, and comprehensive collection management.';

function ensureMetaTag(attr, key) {
  if (typeof document === 'undefined') return null;
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  return tag;
}

function setMetaTag(attr, key, content) {
  if (!content || typeof document === 'undefined') return;
  const tag = ensureMetaTag(attr, key);
  if (tag) tag.setAttribute('content', content);
}

function setCanonical(url) {
  if (!url || typeof document === 'undefined') return;
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', url);
}

function PageMeta({ title, description, image, url }) {
  const resolvedTitle = title || 'Lilycove';
  const resolvedDescription = description || DEFAULT_DESCRIPTION;
  const resolvedImage = image || DEFAULT_OG_IMAGE;
  const resolvedUrl =
    url || (typeof window !== 'undefined' ? window.location.href : undefined);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = resolvedTitle;
    }
    setMetaTag('name', 'title', resolvedTitle);
    setMetaTag('name', 'description', resolvedDescription);
    setMetaTag('property', 'og:title', resolvedTitle);
    setMetaTag('property', 'og:description', resolvedDescription);
    setMetaTag('property', 'og:image', resolvedImage);
    if (resolvedUrl) {
      setMetaTag('property', 'og:url', resolvedUrl);
      setCanonical(resolvedUrl);
    }
    setMetaTag('property', 'twitter:title', resolvedTitle);
    setMetaTag('property', 'twitter:description', resolvedDescription);
    setMetaTag('property', 'twitter:image', resolvedImage);
  }, [resolvedTitle, resolvedDescription, resolvedImage, resolvedUrl]);

  return null;
}

export default PageMeta;
